import {Cookies} from '../shared/cookies-extended';
import {isAnyModalOpened} from '../components/modals/modals';
import Axios from 'axios';
import PopUpShowTimer from './pop-up-show-timer';

const initClientUserLocationGetter = (
    setLocationUrl,
    cookieAcceptLocationKey,
    cookieAcceptLocationExpirationLen,
    cookieWeekExpirationLen) => {
    const retryTimeout = 5000;

    function tryGetUserLocation() {
        if (!isAnyModalOpened()) {
            if (navigator && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(saveUserLocation, errorGetPosition);
            }
        } else {
            setTimeout(() => tryGetUserLocation(), retryTimeout);
        }
    }

    function saveUserLocation(position) {
        const data = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            providedByUser: true,
        };
        Axios.post(setLocationUrl, data)
            .then(() => Cookies.setWithBackupAsync(cookieAcceptLocationKey, true, {expires: cookieAcceptLocationExpirationLen}))
            .catch((msg) => console.log(msg));
    }

    function errorGetPosition(error) {
        switch (error.code) {
        case error.PERMISSION_DENIED:
            Cookies.setWithBackupAsync(cookieAcceptLocationKey, false, {expires: cookieWeekExpirationLen});
            break;
        case error.POSITION_UNAVAILABLE:
        case error.TIMEOUT:
        case error.UNKNOWN_ERROR:
        default:
            break;
        }
    }

    const timerOptions = {
        delayTime: 20000,
        name: 'AskGeolocation',
        extraLongExpiration: cookieAcceptLocationExpirationLen,
    };

    new PopUpShowTimer(timerOptions)
        .start()
        .then(tryGetUserLocation);
};

export default initClientUserLocationGetter;
